import React from 'react';
import {
  BodyText,
  Input,
  RadioGroup,
  Select,
} from '@chargify/custom-ui-components';
import { CustomField } from '../types';

type FormFieldProps = {
  onChange: (id: number, value: string | number) => void;
  options?: string[];
  maxLength?: number;
  portalContainer?: React.RefObject<HTMLDivElement>;
} & Pick<CustomField, 'id' | 'name' | 'fieldType' | 'value'>;

export const renderField = ({
  id,
  name,
  value,
  fieldType,
  options,
  onChange,
  maxLength,
  portalContainer,
}: FormFieldProps) => {
  const onValueChange = (newValue: string | number) => onChange(id, newValue);
  switch (fieldType) {
    case 'text':
      return (
        <Input
          value={value as string}
          onChange={(e) => onValueChange(e.target.value)}
          name={name}
          maxLength={maxLength}
          id={`${id}`}
        />
      );
    case 'dropdown':
      const selectOptions = options.map((option) => ({
        label: option,
        value: option,
      }));
      return (
        <Select
          portalContainer={portalContainer}
          options={selectOptions}
          selectedValue={value}
          onSelect={(item) => onValueChange(item.value)}
        />
      );
    case 'radio':
      const radioOptions = options.map((option) => ({
        label: option,
        value: option,
      }));
      return (
        <RadioGroup
          options={radioOptions}
          onValueChange={onValueChange}
          selectedValue={value}
        />
      );
    default:
      return <BodyText>Field type not recognized: {fieldType}</BodyText>;
  }
};
